module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"projectQuota":"@:common.project额度","disconnectWXhint":"解除微信绑定后，您的微信号将不会收到@:common.project生成状态的推送，以及一些与微信相关的功能也会收到限制。是否继续？"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/profile/account/index.vue
// module id = 338
// module chunks = 3